import { render, staticRenderFns } from "./AppPrivacyPolicyModal.vue?vue&type=template&id=f18f67a4&scoped=true"
import script from "./AppPrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./AppPrivacyPolicyModal.vue?vue&type=script&lang=js"
import style0 from "./AppPrivacyPolicyModal.vue?vue&type=style&index=0&id=f18f67a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18f67a4",
  null
  
)

export default component.exports